var s = document.createElement("script");
s.src = "https://api.wcx.cloud/widget/?id=c9adce6e93c64ddfa6eeac6606a3341c";
document.head.appendChild(s);

document.addEventListener("wcxChatReady", function () {
	const parent = document.querySelector("#wcx-chat");
	const { settings } = _wcchat.getState();

	setTimeout(() => {
		const button = parent.querySelector("button");

		if (settings.available_agent === false) {
			button.classList.add("no-available");
			button.style.background = "#CCCCCC";
		}
	}, 300);
});
